/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyDto } from '../../models/api-key-dto';

export interface AuthControllerGetApiKey$Params {
}

export function authControllerGetApiKey(http: HttpClient, rootUrl: string, params?: AuthControllerGetApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyDto>> {
  const rb = new RequestBuilder(rootUrl, authControllerGetApiKey.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeyDto>;
    })
  );
}

authControllerGetApiKey.PATH = '/auth/api-key';
